import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    privacy_footer_text: {
      id: 'privacy_footer_text',
      defaultMessage: "Privacy",
      description: '',
    },
    cookies_footer_text: {
      id: 'cookies_footer_text',
      defaultMessage: "Cookies",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/Footer/Messages.js